'use client';
import { useEffect, useCallback, useState } from "react";
import { tss } from "tss-react/mui";
import { OutlinedInput, InputAdornment, Menu, MenuItem } from "@mui/material";
//import { Scrollbars } from "react-custom-scrollbars";
import CustomScroll from "components/CustomScroll";
import { Link } from "react-router-dom";
import { getCachedData } from "api/Cache";
import EventsEmitter from "events/EventsEmitter";
import { MAX_CATEGORY_HIT } from "constants/ui";
import { EntityInfo } from "components";
import { allArrayChildren } from "services/UtilsService";
import { Search } from "@mui/icons-material";
import SearchIcon from '@mui/icons-material/Search';
import { SxProps, Theme } from '@mui/material';
import { Search as SearchT, SearchIconWrapper, StyledInputBase } from './style';
import commonStyles, { iconColor } from "styles/common";
import themeCfg from "config/theme.json";

type SearchGlobalProps = {
  wrapperSx?: SxProps<Theme>;
  sx?: SxProps<Theme>;
};


const useStyles = tss.create(({ theme }) => ({
    globalSearchRoot: {
        marginLeft: 7,
        position: "relative",
        // height: "100%",
        width:'90%',
        //marginRight : 10,
        // background:'#FDFDFD'
    },
    menuList: {
        paddingBottom: "48px !important",
        /*" & .MuiPaper-root": {
            backgroundColor: "#fff"
        }*/
    },
    search: {
        height: 40,
        width: '100%',
        borderRadius: 5,
        marginRight: 20,
        border:'0',
        
    },
    menuHeader: {
        fontWeight: "500",
        marginTop: 10,
        //color: theme.palette.text.primary,//themeCfg.sideTopColor,
        fontSize: '16px !important',
        letterSpacing: 0,
        lineHeight: "16px",
        " &:hover": {
            backgroundColor: "transparent"
        }
    },
    menuItem: {
        paddingLeft: 25,
        paddingRight : 25,
        " &.nohoverBg": {
            width: '100%',
            justifyContent: "center",
           /*" &:hover": {
                backgroundColor: "#fff"
            }*/
        }
    },
    link: {
        textDecoration: "none",
        //color: labelColor,
        position: "relative",
        color: 'inherit',//theme.palette.text.primary,//themeCfg.sideTopColor,
        width: "100%",
        display: "flex",
        " &:hover": {
            backgroundColor: theme.palette.background.default
        }
    },
    section: {
        position: "relative",
        minHeight: 40,
        display: "flex",
        alignItems: "flex-start",
        padding: '15px 15px 25px 15px',
        flexDirection: 'column',
        //background : '#fff',
        width: '100%'
    },
    showMore: {
        height: 25,
        position: "absolute",
        display: "inline-flex",
        minWidth: "20px",
        right: 50,
        padding:15,
        //alignSelf: 'flex-end',
        color:'#28ABE3 !important',
        bottom: 5,
        fontSize: "14px !important",
        cursor: "pointer",
        " &:hover": {
            textDecoration: "underline"
        }
    },
    icon: {
        width: 16,
        height: 16,
        paddingTop: 2,
        paddingRight: 3,
        color: 'inherit',//theme.palette.text.primary,//iconColor,
    },
}));

var keyword = "";

const initShowMore = {
    projects: false,
    views: false,
    entities: false,
};

const initResult = {
    projects: [],
    views: [],
    entities: [],
};

type IProps = {
    label: string;
    type: string;
    results: any;
    showMore: any;
    showAll: (type: string) => void;
    showLess: (type: string) => void;
};

const SearchSection = (props: IProps) => {
    const { classes, cx } = useStyles();
    const { classes: common } = commonStyles();
    const { label, type, results, showMore, showAll, showLess } = props;
    var kind = type;
    if (type === "projects" || type === "entities") {
        kind = "catalog";
    }
    const eventBroadcast = (kind: string) => {
        EventsEmitter.emit("changeTab", kind);
    };
    return (
        <div>
            {results[type].length === 0 ? (
                ""
            ) : (
                <div className={classes.section}>
                    <MenuItem className={cx(classes.menuHeader/*, common.label*/)} sx={{color: (theme) => theme.palette.text.secondary}}>{label}</MenuItem>
                    
                    {results[type].map((result: any, index: number) => {
                        if (showMore[type]) {
                            if (index < MAX_CATEGORY_HIT) {
                                return (
                                    <Link
                                        key={"result-" + type + "1-" + index}
                                        to={"/" + kind + "/" + result.ID}
                                        className={classes.link}
                                        onClick={(e: any) => eventBroadcast(kind)}
                                    >
                                        <EntityInfo entity={result} />
                                    </Link>
                                );
                            }
                        } else {
                            return (
                                <Link
                                    key={"result-" + type + "2-" + index}
                                    to={"/" + kind + "/" + result.ID}
                                    className={classes.link}
                                >
                                    <EntityInfo entity={result} />
                                </Link>
                            );
                        }
                        return null;
                    })}
                    
                   
                    {showMore[type] ? (
                        <span className={cx(classes.showMore, common.smallLabel)} onClick={() => showAll(type)}>
                            Show More
                        </span>
                    ) : results[type].length > MAX_CATEGORY_HIT ? (
                        <span className={cx(classes.showMore, common.smallLabel)} onClick={() => showLess(type)}>
                            Show Less
                        </span>
                    ) : (
                        ""
                    )}
                </div>
            )}
        </div>
    );
};


const SearchGlobalProject = ({ wrapperSx, sx }: SearchGlobalProps) => {

	const { classes, cx } = useStyles();
    const { classes: common } = commonStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const [results, setResults] = useState(initResult);
    const [showMore, setShowMore] = useState(initShowMore);
    const data = getCachedData();
    const projects = Object.values(data["projects"]);
    var entities: any = Object.values(data["entities"]);


	const handleChange = useCallback(
		(evt: any, byPass?: boolean) => {
			if (evt.keyCode !== 13 && !byPass) {
				return;
			}
			if (!byPass) {
				keyword = evt.target.value.toLowerCase();
			}
			keyword = keyword.trim();
			console.log("keyword:", keyword);
	
			var newShowMore: any = { ...initShowMore };
			var newResults: any = { ...initResult };
			if (keyword.length === 0) {
				setResults({ ...newResults });
				setAnchorEl(evt.currentTarget);
				return;
			}
			try {
				const regex = new RegExp(keyword, "g");
				var allEntities: any = allArrayChildren(entities);
				newResults.views = allEntities.filter((entity: any) => {
					return (
						entity.state === "COMPLETE" &&
						entity.virtual !== "1" &&
						entity.view_type === "container" &&
						entity.name &&
						entity.name.toLowerCase().match(regex)
					);
				});
				if (newResults.views.length > MAX_CATEGORY_HIT) {
					newShowMore = { ...newShowMore, views: true };
				}
				newResults.projects = projects.filter((project: any) => {
					return project.name && project.name.toLowerCase().match(regex);
				});
				if (newResults.projects.length > MAX_CATEGORY_HIT) {
					newShowMore = { ...newShowMore, projects: true };
				}
	
				const filterFunc = (entity: any) => {
					return (
						entity.state === "COMPLETE" &&
						entity.virtual !== "1" &&
						entity.view_type !== "container" &&
						entity.name &&
						entity.name.toLowerCase().match(regex)
					);
				};
	
				newResults.entities = allEntities.filter(filterFunc);
				if (newResults.entities.length > MAX_CATEGORY_HIT) {
					newShowMore = { ...newShowMore, entities: true };
				}
				setShowMore(newShowMore);
				setResults(newResults);
				if (!byPass) {
					setAnchorEl(evt.currentTarget);
				}
			} catch (e) {}
		},
		[projects, entities]
	);
	const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const showAll = (type: string) => {
        var newShowMore: any = { ...showMore };
        newShowMore[type] = false;
        setShowMore(newShowMore);
    };
    const showLess = (type: string) => {
        var newShowMore: any = { ...showMore };
        newShowMore[type] = true;
        setShowMore(newShowMore);
    };

	return (
		<div className={classes.globalSearchRoot}>
			<SearchT sx={wrapperSx ?? {}}>
				<SearchIconWrapper>
					<SearchIcon />
				</SearchIconWrapper>

				<StyledInputBase
					name='search-globally'
					placeholder='Search anything'
					inputProps={{ 'aria-label': 'search' }}
					sx={sx ?? {}}
					onKeyDownCapture={handleChange}
				/>
			</SearchT>
			<Menu
                id="menu-list-search-grow"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                className={classes.menuList}
            >
                <CustomScroll autoHeight autoHeightMax={500} style={{ overflowX: "hidden", minWidth: 1000, minHeight: 50, maxWidth: "85%" }}>
                    {results.entities.length + results.projects.length + results.views.length === 0 ? (
                        <div className={common.middle} style={{ height: 50, width: "100%" }}>
                            <MenuItem className={cx(classes.menuItem, common.smallLabel, 'nohoverBg')}>No Results</MenuItem>
                        </div>
                    ) : (
                        <div>
                            <SearchSection
                                label="Views"
                                type="views"
                                results={results}
                                showMore={showMore}
                                showAll={showAll}
                                showLess={showLess}
                            />
                            <SearchSection
                                label="Projects"
                                type="projects"
                                results={results}
                                showMore={showMore}
                                showAll={showAll}
                                showLess={showLess}
                            />
                            <SearchSection
                                label="Entities"
                                type="entities"
                                results={results}
                                showMore={showMore}
                                showAll={showAll}
                                showLess={showLess}
                            />
                        </div>
                    )}
                </CustomScroll>
            </Menu>
		</div>
	);
};

export { SearchGlobalProject };
